import React from 'react';
import { FaCheck, FaVideo } from 'react-icons/fa';
import { Spinner } from '../styled/spinner';

interface IProps {
  status: string;
  disabled: boolean;
  onConfirmed: Function;
  startRecording: Function;
  stopRecording: Function;
}

const ButtonGroup: React.FC<IProps> = ({
  status,
  disabled,
  onConfirmed,
  startRecording,
  stopRecording,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <button
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          border: 'none',
          color: 'white',
          backgroundColor: status === 'recording' ? '#324147' : '#c26763',
          padding: '15px',
          fontSize: '15px',
          cursor: 'pointer',
          flex: 1,
        }}
        onClick={() =>
          status === 'recording' ? stopRecording() : startRecording()
        }
      >
        {status === 'acquiring_media' ? (
          <Spinner />
        ) : (
          <>
            <FaVideo fontSize={20} style={{ marginRight: 5 }} color="white" />{' '}
            {status === 'recording' ? 'Stop Recording' : 'Start Recording'}
          </>
        )}
      </button>
      <button
        disabled={disabled}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          border: 'none',
          color: 'white',
          backgroundColor: disabled ? '#c9c9c9' : '#75BF9A',
          padding: '15px',
          fontSize: '15px',
          cursor: disabled ? 'unset' : 'pointer',
          flex: 1,
        }}
        onClick={() => onConfirmed()}
      >
        <FaCheck fontSize={20} style={{ marginRight: 5 }} color="white" />{' '}
        Confirm
      </button>
    </div>
  );
};

export default ButtonGroup;
